import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../images/oup-full-logo-blue-rgb.svg';

const OupHeader = props => (
  <div className={`oup-header ${props.isSticky ? 'oup-header--sticky' : ''}`}>
    <img className="oup-header--logo" src={logo} alt="Oxford University Press" />
    <div className="oup-header--controls">{props.children}</div>
  </div>
);

OupHeader.defaultProps = {
  children: undefined,
  isSticky: false,
};

OupHeader.propTypes = {
  children: PropTypes.node,
  isSticky: PropTypes.bool,
};

export default OupHeader;



// WEBPACK FOOTER //
// ./src/components/OupHeader/OupHeader.js